// src/lib/mandateBranch.js — splits mandates by taxonomy branch, Funds
// first, then Direct Deals (Matt, 10/8). mandate_type comes from
// mandate_profile (DD / FS); a mandate without exactly one profile lands in
// Other so it is never hidden.
export const BRANCHES = [
  { key: 'FS', label: 'Funds' },
  { key: 'DD', label: 'Direct Deals' },
  { key: null, label: 'Other' },
]

export function groupByBranch(mandates) {
  return BRANCHES
    .map(b => ({
      ...b,
      items: mandates.filter(m => (b.key ? m.mandate_type === b.key : !['FS', 'DD'].includes(m.mandate_type))),
    }))
    .filter(g => g.items.length)
}

// Second level, within a branch: one group per work type the mandate is
// engaged for (mandates.work_type, from the EL). A mandate engaged for both
// types shows in both groups; it is still one mandate and one record, the
// grouping is display only. Returns null when nothing in the list has a work
// type (e.g. the portal's non-engaged mandates), so callers skip the level.
const WORK_GROUPS = ['Financial Advisory', 'Strategic Advisory']

export function groupByWorkType(mandates) {
  if (!mandates.some(m => m.work_type?.length)) return null
  return [
    ...WORK_GROUPS.map(type => ({ key: type, label: type, items: mandates.filter(m => m.work_type?.includes(type)) })),
    { key: null, label: 'Work type not set', items: mandates.filter(m => !m.work_type?.length) },
  ].filter(g => g.items.length)
}
